import request from '@/utils/http';
// 综合评分结果表头
export const resultHead = (params) => {
    return request({
        url: `/api-srm-web/bid/bidGetCompositeScoreTeams`,
        method: 'post',
        data: params
    });
};
// 综合评分结果父节点
export const resultParent = (params) => {
    return request({
        url: `/api-srm-web/bid/bidGetResultSupplierParendList`,
        method: 'post',
        data: params
    });
};
// 综合评分结果子节点
export const resultChildren = (params) => {
    return request({
        url: `/api-srm-web/bid/bidGetFinalScoreResult`,
        method: 'post',
        data: params
    });
};
// 推送评分
export const pullGrade = (params) => {
    return request({
        url: `/api-srm-web/bid/bidPushScoreTask`,
        method: 'post',
        data: params
    });
};
// 发起报价
export const offerGrade = (params) => {
    return request({
        url: `/api-srm-web/bid/firstTender`,
        method: 'post',
        data: params
    });
};